import { NavigationProp } from '@react-navigation/native';
import React, { useEffect } from 'react';
import type {PropsWithChildren} from 'react';
import { enumPages } from '../App';
type SectionProps = PropsWithChildren<{
  navigation: NavigationProp<any, any>;
}>;

function SetDinamicPages({navigation}:SectionProps): JSX.Element {
  useEffect(()=>{
    navigation.navigate(enumPages.inicio);
  }, [navigation]);
  return (
    <></>
  );
}

export default SetDinamicPages;
